// Project
import request from "../request";

export const getPerformYardUsers = async () => {
	const response = await request({
		url: "logan/users",
	});

	return response.data;
};
